import { find } from 'lodash-es';

export const carouselChannelSelector = (channelId) => (state) =>
  find(state.carousels, (carousel) => carousel.channelId === channelId);
